module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-lookup",
    on: {
      "mouseenter": _vm.mouseenter,
      "mouseleave": _vm.mouseleave,
      "click": _vm.show
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.computedDisabled,
      "value": _vm.inputText,
      "placeholder": _vm.placeholder,
      "readonly": ""
    }
  }), _vm._v(" "), (!_vm.showClose) ? _c('rt-icon', {
    attrs: {
      "name": "rt-base-lookup"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showClose) ? _c('rt-icon', {
    attrs: {
      "name": "rt-base-close"
    },
    on: {
      "click": _vm.clear
    }
  }) : _vm._e(), _vm._v(" "), _c('rt-dialog', {
    attrs: {
      "append-to-body": true,
      "title": _vm.title
    },
    on: {
      "confirm": _vm.confirm,
      "cancel": _vm.cancel
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('rt-lookup-view', {
    attrs: {
      "fetch": _vm.fetchRecord,
      "display-fields": _vm.displayFields,
      "multiple": _vm.multiple,
      "title": _vm.title
    },
    on: {
      "change": _vm.change
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6585722f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/lookup/rtCrmLookup.vue
// module id = 2107
// module chunks = 228